<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Editar Acreedor
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="investor_details" v-if="loaded"/>
        <!--end: Details -->
        <hr class="mt-4"/>
        <!--begin: Fiscal Info -->
          <div class="row mt-4">
              <div class="col-sm col-md col-lg">
                  <h4 class="m--font-info">Datos fiscales</h4>
              </div>
          </div>
          <sys-form :inputs="fiscal_data" v-if="loaded"/>
        <!--end: Fiscal Info -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'investor', params: { id: investor.id } })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import investorsService from '@/services/investors'
import promotersService from '@/services/promoters'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      loaded: false,
      investor: {},
      investor_details: {
        promoter_id: {
          name: 'Promotor',
          value: '',
          type: 'select',
          size: 12,
          validate: 'required'
        },
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido Paterno',
          hint: 'Apellido Paterno',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido Materno',
          hint: 'Apellido Materno',
          value: '',
          type: 'text',
          size: 3,
          validate: 'required'
        },
        type: {
          name: 'Tipo',
          value: '',
          type: 'select',
          options: [
            { value: 'Fisica', text: 'Física', selected: true },
            { value: 'Moral', text: 'Moral' }
          ],
          size: 3,
          validate: 'required'
        },
        email: {
          name: 'Correo',
          hint: 'Correo',
          value: '',
          type: 'email'
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text'
        },
        mobile: {
          name: 'Celular',
          hint: 'Celular',
          value: '',
          type: 'text'
        },
        curp: {
          name: 'CURP',
          hint: 'CURP',
          value: '',
          type: 'text'
        },
        nationality: {
          name: 'Nacionalidad',
          hint: 'Nacionalidad',
          value: '',
          type: 'text'
        },
        dob: {
          name: 'Fecha de Nacimiento',
          value: '',
          type: 'date'
        },
        corporate_name: {
          name: 'Razón Social',
          hint: 'Razón Social',
          value: '',
          type: 'text'
        },
        description: {
          name: 'Descripción',
          hint: 'Observaciones',
          value: '',
          type: 'textarea',
          size: 12
        }
      },
      fiscal_data: {
        rfc: {
          name: 'RFC',
          hint: 'RFC',
          value: '',
          type: 'text',
          validate: 'required'
        },
        street: {
          name: 'Calle',
          hint: 'Calle',
          value: '',
          type: 'text'
        },
        number: {
          name: 'Número ext./int.',
          hint: 'Número ext./int.',
          value: '',
          type: 'number',
          min: 0,
          max: 9999,
          size: 2
        },
        zip: {
          name: 'Código postal',
          hint: 'Código postal',
          value: '',
          type: 'number',
          min: 0,
          max: 99999,
          size: 2
        },
        neighborhood: {
          name: 'Colonia',
          hint: 'Colonia',
          value: '',
          type: 'text'
        },
        city: {
          name: 'Municipio',
          hint: 'Municipio',
          value: '',
          type: 'text'
        },
        state: {
          name: 'Estado',
          hint: 'Estado',
          value: '',
          type: 'text'
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    investorsService.getById(this.$route.params.id).then(res => {
      this.investor = res.data

      Object.keys(this.investor_details).forEach(key => {
        this.investor_details[key].value = this.investor[key]
      })

      if (this.investor.fiscal_data) {
        Object.keys(this.fiscal_data).forEach(key => {
          this.fiscal_data[key].value = this.investor.fiscal_data[key]
        })
      }

      if (this.investor.type == 'Fisica') {
        delete this.investor_details['corporate_name']
      }

      promotersService.list().then(res => {
        this.investor_details.promoter_id.options = res.data.map(promoter => {
          return { value: promoter.id, text: promoter.fullname }
        })

        this.investor_details.promoter_id.value = { value: this.investor.promoter_id, text: this.investor.promoter_name }

        this.loaded = true
      })
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.investor_details)

          let fiscalData = this.processForm(this.fiscal_data)
          if (Object.keys(fiscalData).length) body['fiscal_data'] = fiscalData

          let service = investorsService.updateById(this.investor.id, body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'investor', params: { id: this.investor.id } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },
  watch: {
    'investor_details.type.value': function (type, oldType) {
      if (type.value === 'Moral') {
        this.investor_details['corporate_name'] = {
          name: 'Razón Social',
          hint: 'Razón Social',
          value: '',
          type: 'text'
        }
      } else if (type.value === 'Fisica') {
        delete this.investor_details['corporate_name']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/investors/InvestorUpdate.vue